import { Spinner } from '@lawpilots/design-system'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const FullScreenProgress = (): JSX.Element => {
  const { t, ready } = useTranslation('general', { useSuspense: false })

  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }}>
      <Spinner size="lg" label={ready ? t('page_loading') : undefined} />
    </Box>
  )
}
